var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGradient = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1052 905"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "gradient_svg__a",
  width: 1053,
  height: 905,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h1053v905H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#gradient_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#gradient_svg__b)",
  d: "M284.779 686.886C32.721 594.347-63.258 288.096 90.874 68.176L381.68-346.756c190.582-271.929 608.589-215.447 720.11 97.302l214.04 600.276c116.44 326.577-200.76 640.89-526.206 521.408z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient_svg__b",
  x1: -633.24,
  x2: 1283.02,
  y1: 604.679,
  y2: -24.691,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2A0E53"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467,
  stopColor: "#9233CB",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.696,
  stopColor: "#BF56DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#BF56DE",
  stopOpacity: 0.65
})))));
export default SvgGradient;